export class SgfDescuento {
    id:{
        codProducto: any;
        codCuenta: any;
        numDescuento: any;
        numSecuencia: any;
        fecVencimiento: string;
    }
    nomEmpresa: string;
    numCuotas: string;
    numCuota: string;
    valSaldoCapital:string;
    valCapital: number;
    fecMov: string;
}
